<template>
    <ul class="w-[15rem] space-y-5 p-5 text-16/120 font-semibold">
        <li
            v-for="item in items"
            :key="item.link">
            <NuxtLink
                :to="item.link"
                class="flex items-center text-ash transition-colors duration-300 hover:text-accent"
                @click="emits('close')">
                <AtomIcon
                    :name="item.icon"
                    :class="isRadioguide() ? 'h-auto w-[38px]' : 'size-6'"
                    class="inline" />
                <span class="ml-3">{{ item.title }}</span>
            </NuxtLink>
        </li>
    </ul>
</template>

<script setup lang="ts">
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import type { IHeaderLinkItem } from '~/components/layouts/header/header.types'

defineProps({
    items: {
        type: Array as PropType<IHeaderLinkItem[]>,
        default: () => [
            {
                title: 'О компании',
                icon: 'logo',
                link: '/about',
            },
            {
                title: 'Доставка и оплата',
                icon: 'car',
                link: '/delivery-and-payment',
            },
            {
                title: 'Гарантии и сервис',
                icon: 'wrench',
                link: '/warranty-and-service',
            },
            {
                title: 'Отзывы',
                icon: 'star',
                link: '/reviews',
            },
            {
                title: 'Вопрос-ответ',
                icon: 'question',
                link: '/faq',
            },
            {
                title: 'СМИ о нас',
                icon: 'tv',
                link: '/media',
            },
            {
                title: 'Новости',
                icon: 'news',
                link: '/news',
            },
            {
                title: 'Видео',
                icon: 'video',
                link: '/videos',
            },
            {
                title: 'Блог PRO',
                icon: 'note',
                link: '/pro',
            },
        ],
    },
})
const emits = defineEmits(['close'])
</script>
